import { render } from "./Answer.vue?vue&type=template&id=a0b946b8&scoped=true"
import script from "./Answer.vue?vue&type=script&lang=js"
export * from "./Answer.vue?vue&type=script&lang=js"

import "./Answer.vue?vue&type=style&index=0&id=a0b946b8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\holo\\work\\git-all-source,\\stress_check_Rebuild\\source\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b946b8"]])

export default __exports__